import React from 'react';
import ISummaryRow, { ISummaryTable } from './ISummaryTable';
import * as elements from '@appStyles/_elements.module.scss';
import * as style from './SummaryTableStyle.module.scss'
import { classNames } from '@features/utils/reactFunctions';

const SummaryTable: React.FunctionComponent<ISummaryTable> = (props) => {
  return (
    <div className={classNames(elements.zebraTableContainer, style.table, props.className)}>
      {props.children}
    </div>
  );
};

export const SummaryTableRow: React.FunctionComponent<ISummaryRow> = (props) => {
  return (
    <div className={classNames(elements.zebraTableRow, style.row, props.className)}>
      <div className={classNames(style.item, style.itemLabel)}>{props.label}</div>
      <div className={classNames(style.item, style.itemValue)}>{props.value}</div>
    </div>
  );
};

export default SummaryTable;
